import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
  form {
    display: flex;
    flex-flow: column;
    gap: ${csSpacing.spacing06};
  }
`
